'use strict';

var setScrollHeight = require('../util/setScrollHeight');

const tabs = {
    syncInstanceTabHeight($instanceWrapper) {
        $('.bbw-pdp-tabs').each(function () {
            const contentHeight = $instanceWrapper.find('.bbw-pdp-tabs__tab--active .bbw-pdp-tabs__tab-content').outerHeight();

            $instanceWrapper.find('.bbw-pdp-tabs__tab--active .bbw-pdp-tabs__tab-content-wrapper').height(contentHeight);
        });
    },
    attachInstanceEventHandlers($instanceWrapper) {
        $instanceWrapper.on('click', '.bbw-pdp-tabs__tab-toggle-cta', function () {
            const $cta = $(this);
            const $tab = $cta.closest('.bbw-pdp-tabs__tab');
            const wasExpanded = $tab.hasClass('bbw-pdp-tabs__tab--active');
            const isDesktop = ['medium', 'large', 'extraLarge', 'extraExtraLarge'].includes(window.currentBreakpoint);

            $('.bbw-pdp-tabs__tab-toggle-cta').attr('aria-selected', 'false');
            $(this).attr('aria-selected', 'true');

            if (!isDesktop || (isDesktop && !wasExpanded)) {
                $instanceWrapper.find('.bbw-pdp-tabs__tab--active').removeClass('bbw-pdp-tabs__tab--active');
                $tab.toggleClass('bbw-pdp-tabs__tab--active', !wasExpanded);

                if (isDesktop) {
                    tabs.syncInstanceTabHeight($instanceWrapper);
                }
            }
        });
    },
    initInstance($tabsInstanceWrapper) {
        tabs.attachInstanceEventHandlers($tabsInstanceWrapper);

        if (['medium', 'large', 'extraLarge', 'extraExtraLarge'].includes(window.currentBreakpoint)) {
            if (!$tabsInstanceWrapper.find('.bbw-pdp-tabs__tab--active').length) {
                $tabsInstanceWrapper.find('.bbw-pdp-tabs__tab:eq(0)').addClass('bbw-pdp-tabs__tab--active').children('.bbw-pdp-tabs__tab-toggle-cta').attr('aria-selected', 'true');
            }
            tabs.syncInstanceTabHeight($tabsInstanceWrapper);
        }
    },
    init() {
        setScrollHeight.init();

        $('.bbw-pdp-tabs').each(function () {
            tabs.initInstance($(this));
        });

        window.jRes.addFunc([
            {
                breakpoint: ['medium', 'large', 'extraLarge', 'extraExtraLarge'],
                enter: function () {
                    $('.bbw-pdp-tabs').each(function () {
                        tabs.syncInstanceTabHeight($(this));
                    });
                },
                exit: function () {
                    $('.bbw-pdp-tabs__tab-content-wrapper').each(function () {
                        $(this).removeAttr('style');
                    });
                    setScrollHeight.refresh();
                }
            }
        ]);
    }
};

module.exports = tabs;
